import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const AttrColorIcon = React.memo<IconProps>(({ 
  className = '',
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth
}) => (
  <BaseIcon
    className={className}
    size={size}
    color={color}
    onClick={onClick}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
  >
    <path d="M12.02 0C5.41 0 0 5.38 0 12C0 18.62 5.38 24 12 24C13.56 24 14.83 22.73 14.83 21.22C14.88 20.38 14.48 19.8 14.19 19.37C13.97 19.06 13.89 18.91 13.9 18.72C13.9 18.26 14.27 17.89 14.73 17.89H16.89C20.81 17.89 24 14.7 24 10.78C24 4.85 18.62 0.02 12.02 0ZM16.89 15.89H14.73C13.17 15.89 11.9 17.16 11.9 18.67C11.86 19.51 12.26 20.08 12.55 20.51C12.77 20.82 12.85 20.97 12.84 21.17C12.84 21.63 12.47 22 12.01 22C6.5 22 2.01 17.51 2.01 12C2.01 6.49 6.48 2.02 11.98 2C17.49 2 22 5.94 22 10.78C22 13.6 19.71 15.89 16.89 15.89Z" fill={color}/>
    <path d="M5.28003 12.17C6.3846 12.17 7.28003 11.2746 7.28003 10.17C7.28003 9.06544 6.3846 8.17001 5.28003 8.17001C4.17546 8.17001 3.28003 9.06544 3.28003 10.17C3.28003 11.2746 4.17546 12.17 5.28003 12.17Z" fill={color}/>
    <path d="M8.94 7.28C10.0446 7.28 10.94 6.38457 10.94 5.28C10.94 4.17543 10.0446 3.28 8.94 3.28C7.83543 3.28 6.94 4.17543 6.94 5.28C6.94 6.38457 7.83543 7.28 8.94 7.28Z" fill={color}/>
    <path d="M15.06 7.28C16.1646 7.28 17.06 6.38457 17.06 5.28C17.06 4.17543 16.1646 3.28 15.06 3.28C13.9554 3.28 13.06 4.17543 13.06 5.28C13.06 6.38457 13.9554 7.28 15.06 7.28Z" fill={color}/>
    <path d="M18.72 12.17C19.8245 12.17 20.72 11.2746 20.72 10.17C20.72 9.06544 19.8245 8.17001 18.72 8.17001C17.6154 8.17001 16.72 9.06544 16.72 10.17C16.72 11.2746 17.6154 12.17 18.72 12.17Z" fill={color}/>
  </BaseIcon>
));

AttrColorIcon.displayName = 'AttrColorIcon';
